export default __webpack_public_path__ + "static/media/saree.c99a8ab8.jpg";